import { RouteInterface } from '@/src/common/enums/routes'
import { HomeTab } from './tab'

export const Routes = {
  Home: {
    route: `/main/(tabs)/${HomeTab.home.name}`,
    name: HomeTab.home.name,
    availableForDeepLinking: true,
    aliases: [`/main/${HomeTab.home.name}`],
  },
} as const satisfies Record<string, RouteInterface>

export default Routes
